import JuiceIt from "../../../../content/blog/juice-it/src/JuiceIt.tsx";
import * as React from 'react';
export default {
  JuiceIt,
  React
};